import { lazy, Suspense } from "react";
import { Redirect, BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import VaultSpinner from "./globalComponents/VaultSpinner/VaultSpinner";
import jQuery from "jquery";
// STYLES
import styles from "./app.module.css";
import PrivateRoute from "./PrivateRoute";

// LAZY LOADED/DYNAMIC IMPORTS (CODE SPLITTING) only loaded in when the Component is requested

const Login = lazy(() => import("./pages/Login/Login"));
const Home = lazy(() => import("./pages/Home/Home"));
const Autopay = lazy(
  () => import("./pages/Autopay/AutoPay"),
);
const Enrollment = lazy(
  () => import("./pages/Autopay/Enrollment"),
);
// const NoAuthHome = lazy(() => import("./pages/NoAuthHome/NoAuthHome"));
const QuickPay = lazy(() => import("./pages/QuickPay/QuickPay"));


function App() {
  // @ts-ignore
  window.jQuery = jQuery;
  return (
    <div className={styles.appContainer}>
      {process.env.REACT_APP_AUTH_FLAG === "true" ? (

        <Router>
          <Switch>
            <Suspense
              fallback={
                <div className={styles.spinnerWrapper}>
                  <VaultSpinner />
                </div>
              }
            >
              <Route
                exact
                path="/"
                render={({ location }) => (
                  <Redirect
                    to={{
                      pathname: "/quickpay",
                      search: location.search,
                    }}
                  />
                )}
              />
              <Route exact path="/login" component={Login} />
              <Route exact path="/quickpay" component={QuickPay} />
              {/*<SecureRoute exact path="/about" component={About} />*/}
              {/*<Route exact path="/quickpay" component={QuickPay} />*/}

              <PrivateRoute>
                <Route exact path="/home" component={Home} />
                <Route exact path="/autopay" component={Autopay} />
                <Route exact path="/enrollment" component={Enrollment} />               
                {/* <Route path="/login" render={() => <Login config={oktaSignInConfig} />} />
                <Route path="/login/callback" component={LoginCallback} /> */}
              </PrivateRoute>
              <ToastContainer />
            </Suspense>
          </Switch>
        </Router>

      ) : (
        <Router>

          <Switch>
            <Suspense
              fallback={
                <div className={styles.spinnerWrapper}>
                  <VaultSpinner />
                </div>
              }
            >
              {/* <Route exact path="/" component={NoAuthHome} /> */}
              <ToastContainer />
            </Suspense>
          </Switch>

        </Router>
      )}
    </div>
  );
}

export default App;